// extracted by mini-css-extract-plugin
module.exports =  {"tabContent":"BillingSummaryPage_tabContent__yxClT","billingSummaryContainer":"BillingSummaryPage_billingSummaryContainer__rydYQ"};